<template>
	<group-section :group="group" :item-list-keys="itemListKeys" />
</template>

<script>
import GroupSection from '@/containers/group-section';
import { mapGetters } from 'vuex';

export default {
	name: 'Group',
	components: { GroupSection },
	computed: mapGetters(['group', 'itemListKeys']),
};
</script>
